import styled from 'styled-components';
import { animated } from '@react-spring/web';
import { SellerChipContainer } from '../SellerChip/seller-chip.styles';

export const Container = styled.div`
  padding: 1rem 1rem;
`;
export const Title = styled.p`
  color: ${(p) => p.theme.seller.primary.safeColorInsideContainer};
  font-size: 1.5rem;
  font-weight: bold;
  white-space: nowrap;
  margin: 0.5rem 0;
`;
export const Sellers = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  background-color: ${(p) => p.theme.bg};
  padding: 1rem;
  border-radius: 1rem;
  cursor: pointer;
`;

export const PopupSellers = styled(Sellers)`
  background-color: ${(p) => p.theme.gray[100]};
  cursor: text;
  max-height: 30rem;
  overflow-y: auto;
`;

const ChipHeight = '2rem';

const DeleteSellerIconSize = '1.2rem';

export const DeleteSellerIcon = styled.button`
  color: inherit;
  width: ${DeleteSellerIconSize};
  height: ${DeleteSellerIconSize};
  margin: 0;
  margin-left: 0.5rem;
  border: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
  svg {
    width: ${DeleteSellerIconSize};
    height: ${DeleteSellerIconSize};
    color: inherit;
  }
`;

export const SellerInputWrapper = styled.div`
  width: auto;
  flex: 1 1 60px;
  min-width: 60px;
  padding: 0;
  border: none;
`;

export const SellerInput = styled.input`
  flex: 1;
  border: none;
  height: ${ChipHeight};
  resize: none;
  width: 100%;
  background: transparent;
  color: ${(p) => p.theme.gray[500]};
  font-size: 1.2rem;
  &:focus {
    outline: none;
  }
`;

export const PopupDarkerBackground = styled(animated.div)`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Popup = styled(animated.div)`
  background-color: ${(p) => p.theme.bg};
  font-weight: bold;
  width: 100%;
  max-width: 600px;
  border-radius: 1.2rem;
  box-shadow:
    0px 20px 24px -4px rgba(16, 24, 40, 0.08),
    0px 8px 8px -4px rgba(16, 24, 40, 0.03);

  border: 1px solid ${(p) => p.theme.gray[200]};
`;

export const PopupTitle = styled.div`
  font-size: 1.8rem;
  width: 100%;
  color: ${(p) => p.theme.gray[400]};
  border-bottom: 1px solid ${(p) => p.theme.gray[200]};
  padding: 1.5rem 1.5rem;
`;
export const PopupContent = styled.div`
  padding: 0 1rem;
`;

export const PopupContentDescription = styled.p`
  font-size: 1.4rem;
  color: ${(p) => p.theme.gray[400]};
  padding: 0 1rem;
  width: 100%;
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 1rem;
  gap: 0 1rem;
`;
export const Button = styled.button.attrs<{ $disabled?: boolean }>((p) => ({
  ...p,
  onClick: p.$disabled ? undefined : p.onClick,
}))<{ $disabled?: boolean }>`
  border: none;
  background-color: ${(p) =>
    (p.$disabled as any) ? p.theme.gray[300] : p.theme.colors.green[400]};
  color: ${(p) => p.theme.colors.white[1000]};
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 0.5rem;
  padding: 1rem 1.2rem;
  font-size: 1.6rem;
  font-weight: bold;
  cursor: ${(p) => (p.$disabled ? 'not-allowed' : 'pointer')};
`;

const IconSize = '1.5rem';

export const ButtonIcon = styled.div`
  color: inherit;
  width: ${IconSize};
  height: ${IconSize};
  margin-right: 0.5rem;
  svg {
    width: ${IconSize};
    height: ${IconSize};
    color: inherit;
  }
`;

export const DataSourceSellers = styled(PopupSellers)`
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.5rem;
  ${(p) => p.theme.customScroll(p.theme)};
  cursor: unset;
  gap: 0;
  position: relative;
  background-color: ${(p) => p.theme.bg};
  border: 1px solid ${(p) => p.theme.gray[200]};
`;
export const DataSourceSeller = styled.button`
  width: 100%;
  background: transparent;
  margin: 0;
  color: ${(p) => p.theme.gray[400]};
  font-size: 1.4rem;
  padding: 0.75rem 0.5rem;
  border: none;
  cursor: pointer;
  border-radius: 0.5rem;

  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover,
  &:focus {
    background-color: ${(p) => p.theme.gray[200]};
  }

  outline: none;

  ${SellerChipContainer} {
    margin-right: 0.5rem;
    width: fit-content;
  }
`;

export const SellerDocument = styled.p`
  margin: 0;
  font-size: 1.3rem;
  color: ${(p) => p.theme.gray[400]};
`;

export const EmptyData = styled.p`
  font-size: 1.4rem;
  color: ${(p) => p.theme.gray[400]};
  padding: 0 1rem;
  width: 100%;
`;

export const EmptySelectedData = styled(EmptyData)`
  margin: 0;
  color: ${(p) => p.theme.gray[400]};
`;

export const PopupSmallButton = styled.button`
  border: none;
  background-color: ${(p) => p.theme.gray[200]};
  color: ${(p) => p.theme.gray[500]};

  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 0.5rem;
  padding: 1rem 1.2rem;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 1rem;

  :hover {
    background-color: ${(p) => p.theme.gray[100]};
    color: ${(p) => p.theme.gray[400]};
  }
`;
